export default __webpack_public_path__ + "static/media/Megosu---Thomas-Misse.1d9dec38.jpg";